import { Link, useNavigate } from 'react-router-dom'; // useNavigate-ből importálás
import './style.scss';

function Footer () {

    const navigate = useNavigate();

    const scrollToContentCircles = () => {
        const element = document.getElementById('contentcircles');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const goToHomeAndScroll = () => {
        // Navigálj a Home oldalra
        navigate('/'); 
        
        // Késleltetve hívjuk meg a görgetést a navigálás után
        setTimeout(scrollToContentCircles, 100); // Kis késleltetést adunk a betöltéshez
    };

    return(
        <footer className="footer" style={{ backgroundImage: 'url(/img/leafbg.avif)' }}>
            <div className="container">
                <div className="footer-content">
                    <div className="footer-block">
                        <h2 className="headline">
                            Info
                        </h2>
                        <ul className="information-links">
                            <li>
                                <Link to={"/"}>FŐOLDAL</Link>
                            </li>
                            <li>
                                <Link to={"/about-us"}>RÓLUNK</Link>
                            </li>
                            <li>
                                <button className='footerButton' onClick={goToHomeAndScroll}>SZOLGÁLTATÁSOK</button>
                            </li>
                            <li>
                                <Link to={"/contact"}>KAPCSOLAT</Link>
                            </li>
                            <li>
                                <Link to={"/carreer"}>KARRIER</Link>
                            </li>
                        </ul>
                        <ul className="social-media-links">
                            <li>
                                <a href="https://www.facebook.com/profile.php?id=100057030116693">
                                    <img src="img/fbicon.png" className="social-icon" alt="facebooklogo" />
                                </a>
                            </li>
                            <li>
                                <a href="https://www.instagram.com/vbek_vac">
                                    <img src="img/instaicon.png" className="social-icon" alt="instalogo" />
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="logo">
                        <img src="/img/vbeklogo.png" alt="vbek logo" className="footer-logo" />
                    </div>
                    <div className="footer-block">
                        <h2 className="headline">KAPCSOLAT</h2>
                        <p className="footer-contact-information">
                            <span>Címünk:</span> 2600 Vác, Zrínyi utca 3.
                        </p>
                        
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
